/** @typedef {import('./types.js').MenuStyleProperties} MenuStyleProperties */

/**
 * @param {string | undefined} align
 * @returns {'start' | 'center' | 'end' | undefined}
 */
const normalizeAlign = align => {
    if (!align) {
        return undefined
    }

    return /** @type {'start' | 'center' | 'end'} */ (align.replace('flex-', ''))
}

const getComponentsByType = (components, compType) => {
    const filteredComponents = components.filter(comp => comp.componentType === compType)
    return filteredComponents
}

/**
 * @param {string} prefix
 * @param {MenuStyleProperties} styleProps
 * */
const clearTemporaryPropertiesByPrefix = (prefix, styleProps) => {
    Object.keys(styleProps).forEach(key => {
        // FYI: startsWith supported in all browser versions that Wix supports
        // eslint-disable-next-line @wix/santa/no-starts-with
        if (key.startsWith(prefix)) {
            delete styleProps[key]
        }
    })
}

const MENU_TOP_LEVEL_TEMPORARY_PROPERTIES = [
    'item-container-text-align',
    'container-flex-grow',
    'container-justify-content',
    'item-padding-top',
    'item-padding-right',
    'item-container-justify-content',
    'menu-direction',
    'menu-flex-grow',
    'menu-height',
    'menu-margin-left',
    'menu-margin-right',
    'menu-margin-top',
    'menu-margin-bottom',
    'scroll-button-padding-top',
    'scroll-button-hover-padding-top',
    'scroll-button-padding-bottom',
    'scroll-button-hover-padding-bottom'
]

const clearMenuTopLevelTemporaryProperties = properties => {
    MENU_TOP_LEVEL_TEMPORARY_PROPERTIES.forEach(property => {
        delete properties[property]
    })
}

const DROPDOWN_TEMPORARY_PROPERTIES = [
    'dropdown-container---flyoutAlignment',
    'dropdown-container---horizontalSpacing',
    'dropdown-menu-justify-content',
    'dropdown-margin-right',
    'dropdown-menu---width',
    'dropdown-menu-width',
    'dropdown-menu---columnsAmount',
    'dropdown-menu-text-align'
]

const clearDropdownTemporaryProperties = properties => {
    DROPDOWN_TEMPORARY_PROPERTIES.forEach(property => {
        delete properties[property]
    })
}

const clearMegaMenuTemporaryProperties = properties => {
    clearTemporaryPropertiesByPrefix('mega-menu-', properties)
}

/**
 * @param {object} properties
 * */
const clearTemporaryProperties = properties => {
    clearMenuTopLevelTemporaryProperties(properties)
    clearDropdownTemporaryProperties(properties)
    clearMegaMenuTemporaryProperties(properties)
}

module.exports = {
    normalizeAlign,
    getComponentsByType,
    clearTemporaryProperties
}
